<template>
<div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">
        <div class="row">

            <div class="col-md-12 rolelist">
                <div class="addrole">
                    <router-link to="/admin/dashboard/addcustomer"><a class="">Add Customer</a></router-link>
                </div>
            </div>
            <div class="col-md-12 rolelistupper"> 
                <div class="card">
                    <h5 class="card-title">Customer List</h5>
                    <FlashMessage :position="'right top'"></FlashMessage>

                    <div class="card-body table-responsive table-full-width">

                        <table class="table table-borderd mt-5" id="myTable">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Number</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="data in tableData" v-bind:key="data.id">
                                    <td>{{data.id}}</td>
                                    <td>{{data.name}}</td>
                                    <td>{{data.email}}</td>
                                    <td>{{data.number}}</td>
                                    <td>{{data.status}}</td>
                                    <td><button @click.prevent="deleteData(data.id)" class="btnborderremove">
                                            <a><b-icon-trash></b-icon-trash></a>
                                        </button>&nbsp; &nbsp; <router-link :to="'/admin/dashboard/editcustomer/' + data.id"><button class="btnborderremove">
                                                <a><b-icon-pencil-square></b-icon-pencil-square></a>
                                            </button></router-link>
                                    </td>

                                </tr>
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <content-footer></content-footer>
</div>
</template>

<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import $ from "jquery"
import Vue from 'vue'
import {
    Table,
    TableColumn
} from 'element-ui'
Vue.use(Table)
Vue.use(TableColumn)
export default {
    name: 'listCustomer',

    components: {
        TopNavbar,
        ContentFooter,
    },

    data() {
        return {
            tableData: []
        }
    },

    methods: {

        table() {
            this.$nextTick(() => {
                $('#myTable').DataTable();
            });
        },

        getData() {
            this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/customer`).then((res) => {
                this.tableData = res.data;
                this.table();
            });
        },

        deleteData(id) {
            this.axios.delete(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/user/delete/` + id).then((res) => {
                this.list = res;
                this.getData();
                this.flashMessage.success({
                    message: 'Customer Deleted Successfully',
                });
            });
        },

    },

    mounted() {
        this.getData();
    },

};
</script>

<style lang="scss">
</style>
